import { createSelector } from 'reselect'

const getMasterToken = auth => auth.masterToken;
export const makeGetMasterToken = () => createSelector(getMasterToken, token => token);

const getTeamToken = (auth, teamUrl) => (!teamUrl || auth.teamUrl === teamUrl) && auth.teamToken;
export const makeGetTeamToken = () => createSelector(getTeamToken, token => token);

const getTeamUrl = auth => auth.teamUrl;
export const makeGetTeamUrl = () => createSelector(getTeamUrl, teamUrl => teamUrl);

const getLoggingOut = auth => auth.loggingOut;
export const makeGetLoggingOut = () => createSelector(getLoggingOut, loggingOut => loggingOut);

const getSigningUp = auth => auth.signingUp;
export const makeGetSigningUp = () => createSelector(getSigningUp, signingUp => signingUp);
